import {useState, useEffect, useCallback} from "react";

import useWorkerProcess from "../use-worker-process/use-worker-process";

const defaultFunc = () => {};
const useInterval = ({milliseconds = 10000,
  debug = false,
  autoStart = true,
  onTrigger = defaultFunc}) => {
  const [intervalId, setIntervalId] = useState(-1);

  const restart = useCallback(() => {
    setIntervalId(curId => {
      if (debug) { console.log("restarting");}
      if (curId > 0) {
        clearInterval(curId);
      }
      const id = setInterval(onTrigger, milliseconds);
      return id;
    })
  }, [milliseconds, onTrigger,debug]);
  const stop = useCallback(() => {
    if (debug) { console.log("stopping");}
    setIntervalId(curId => {
      if (curId > 0) {
        clearInterval(curId);
        return -1;
      }
      return curId;
    })
  },[debug]);

  useEffect(() => {
    if (autoStart) {
      restart();
    }
  },[restart, autoStart]);

  useEffect(() => {
    return () => {
      if (intervalId > 0) {
        clearInterval(intervalId);
      }
    }
  },[autoStart, restart, intervalId]);

  return {
    restart,
    stop
  };

}


const useWorkerProcessInterval = ({
  milliseconds = 1000,
  autoStart = true,
  onTrigger = defaultFunc
}) => {
  const {
    execute,
    messageToWorker,
    progress,
  } = useWorkerProcess({file:"workers/interval-worker.js"});


  useEffect(() => {
    if (autoStart) {
      execute({msg:"start"})
    } else {
      execute();//this will set up the worker
      //which then waits for a message passed to messageToWorker
    }
  } ,[autoStart, execute]);

  const restart = useCallback(() => {
    messageToWorker({msg:"start"});

  },[messageToWorker])
  const stop = useCallback(() => {
    messageToWorker({msg:"stop"});//this will clear out the interval in the worker
  },[messageToWorker])

  useEffect(() => {
    onTrigger();
  },[progress,onTrigger])

  return {
    restart,
    stop
  }

}

export {useWorkerProcessInterval};
export default useInterval;